import {Component, OnDestroy, OnInit} from '@angular/core';

import {DialogActionsEnum, DialogComponent} from 'appShared/components';
import {FormInterface, PermissionRuleInterface} from 'appShared/interfaces';
import {FormComponent} from 'appShared/widgets';
import {Subscription} from 'rxjs';
import {AlertsService} from 'appShared/services';
import {MatDialogRef} from '@angular/material/dialog';
import {ApiError, HttpStatusCodesEnum, ServerResponseData} from '@spa/api';
import {AlertTypesEnum} from 'appShared/enums';
import {ApiResponse} from '@spa/api/lib/common';
import {BaseMarketDataForm} from 'appShared/forms';

@Component({
    template: ''
})
export abstract class PanelBaseMarketDataFormDialogComponent<SubComponent>
    extends DialogComponent<SubComponent> implements FormInterface, OnDestroy, OnInit {

    protected subscriptions: Subscription[];
    public permissionRule: PermissionRuleInterface;
    public form: BaseMarketDataForm;

    constructor(
        dialogRef: MatDialogRef<SubComponent>,
        protected alertsService: AlertsService) {
        super(dialogRef);
        this.subscriptions = [];
    }

    abstract getSuccessFormMessage(): string;

    abstract getErrorMessageByApiError(error: ApiError): string;

    abstract initForm(): void;

    handleErrorResponse(response: ApiResponse<ApiError[] | boolean>, error: ApiError): string {
        if (Array.isArray(response.messages) && response.messages[0]) {
            return response.messages[0];
        }

        return this.getErrorMessageByApiError(error);
    }

    onFormSubmit(action?: number): void {
        if (action !== DialogActionsEnum.Confirm) {
            this.dialogRef.close(false);

            return;
        }

        if (this.validateForm()) {
            const requestSubscription = this.form.createRequest()
            .subscribe((response: ServerResponseData<boolean>) => {
                if (response.status !== HttpStatusCodesEnum.Ok) {
                    (response.data as ApiError[]).map((error: ApiError) => this.handleErrorResponse(response, error))
                    .filter((errorMessage: string) => {
                        return errorMessage.trim();
                    }).forEach((errorMessage: string) => {
                        this.alertsService.addAlert(errorMessage);
                    });

                    return;
                }

                this.dialogRef.close(true);
                this.alertsService.addAlert(this.getSuccessFormMessage(), AlertTypesEnum.Success);
            });
            this.subscriptions.push(requestSubscription);
        }
    }

    getFormMessages(controlLabel?: string): { [p: string]: string } {
        return FormComponent.getFormMessages(controlLabel);
    }

    validateForm(): boolean {
        return this.form.validateForm(this.getFormMessages);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => subscription && subscription.unsubscribe());
    }

    ngOnInit(): void {
        this.initForm();
    }
}
